Shopify.queryParams = {};

function returnShopifySectionId() {
  const gridElem = document.querySelector('.mm-collection-grid');
  const gridSection = gridElem.closest('.shopify-section');
  return gridSection.id;
}
function returnShopifySectionIdShort() {
  return returnShopifySectionId().replace('shopify-section-', '');
}

function refreshCollectionPageWithFilters(url_filters) {
	let currentUrl = '//' + location.host + location.pathname;
	//let newPageString = httpGet(currentUrl + '?' + url_filters);
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
	let newPageEl = document.createElement('DIV');
	newPageEl.innerHTML = newPageString;
    console.log('newPageString', newPageString)

	let newSection = newPageEl.querySelector('.mm-collection-grid');
	let newElemsFiltersInner = newPageEl.querySelectorAll('.filter-group-display__list');
	let activeFilters = newPageEl.querySelectorAll('.active-filters');

	document.querySelector('.mm-collection-grid').innerHTML = newSection.innerHTML;
	newElemsFiltersInner.forEach(function (newElemFiltersInner, index) {
		document.querySelectorAll('.filter-group-display__list').forEach(function (elem, elemIndex) {
			if (index == elemIndex) {
				elem.innerHTML = newElemFiltersInner.innerHTML;
			}
		});
	});

	activeFilters.forEach(function (activeFilter) {
		var newActiveFilters = document.querySelectorAll('.active-filters');
		newActiveFilters.forEach(function (newActiveFilter) {
			newActiveFilter.innerHTML = activeFilter.innerHTML;
		});
	});

	var newNumHeader = newPageEl.querySelector('.mm-num-active-filter');
	var newNumFilter = newPageEl.querySelector('.mm-num-active-filter');
	document.querySelector('.mm-num-active-filter').innerHTML = newNumHeader.innerHTML;
	document.querySelector('.mm-num-active-filter-cta').innerHTML = newNumFilter.innerHTML;

	// Mise à jour de mm-collection-grid-load-more
	const newLoadMoreSection = newPageEl.querySelector('.mm-collection-grid-load-more');
	const currentLoadMoreSection = document.querySelector('.mm-collection-grid-load-more');
	
	if (currentLoadMoreSection && newLoadMoreSection) {
		currentLoadMoreSection.innerHTML = newLoadMoreSection.innerHTML;
	}

	window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
	checkForChanges();
}

function httpGet(theUrl) {
	var xmlHttp = null;

	xmlHttp = new XMLHttpRequest();
	xmlHttp.open('GET', theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

function checkForChanges() {
	var form = document.getElementById('collectionFacetsForm');
	var inputs = form.querySelectorAll('input');

	inputs.forEach(function (input) {
		input.addEventListener('change', function (e) {
            setTimeout(() => {
    			fakeSubmitForm();
            }, "1");
		});
	});
}

document.querySelectorAll('.sort_by').forEach(function(select) {
	select.addEventListener('change', function (e) {
		var value = e.target.value;
		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
});

function fakeSubmitForm() {
	let url_filters = $('#collectionFacetsForm').serialize();
	refreshCollectionPageWithFilters(url_filters);
}

window.addEventListener('DOMContentLoaded', (event) => {
	checkForChanges();
	if (window.innerWidth < 900) {
		mmCheckDrawer();
	}
});

if (window.innerWidth < 900) {
	function mmOpenFiltersMobile() {
		var header = document.querySelector('header');
		var wrapperMobile = document.querySelector('.mm-filters-container');
		wrapperMobile.style.top = header.getBoundingClientRect().bottom + 'px';
		wrapperMobile.style.height = 'calc(var(--doc-height) - ' + header.getBoundingClientRect().bottom + 'px)';
		wrapperMobile.classList.add('mm-open');

		document.querySelector('html').classList.add('stop-scrolling');
	}
	function mmCloseFiltersMobile() {
		var wrapperMobile = document.querySelector('.mm-filters-container');
		wrapperMobile.classList.remove('mm-open');

		document.querySelector('html').classList.remove('stop-scrolling');
	}

	function mmCheckDrawer() {
		var currentUrl = document.location.href.indexOf('?open_filters');
		if (currentUrl !== -1) {
			mmOpenFiltersMobile();
		}
	}
}


// Back to top btn
const backToTopBtn = document.getElementById("backToTopButton");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	backToTopBtn.style.display = "block";
  } else {
	backToTopBtn.style.display = "none";
  }
}

function topFunction() {
  // Duration of the scroll animation in milliseconds
  const duration = 500;
  const start = document.documentElement.scrollTop || document.body.scrollTop;
  const startTime = performance.now();

  function scrollStep(timestamp) {
	const currentTime = timestamp - startTime;
	const progress = Math.min(currentTime / duration, 1);
	const ease = 0.5 * (1 - Math.cos(Math.PI * progress));

	document.documentElement.scrollTop = document.body.scrollTop = start * (1 - ease);

	if (currentTime < duration) {
	  window.requestAnimationFrame(scrollStep);
	} else {
	  document.documentElement.scrollTop = document.body.scrollTop = 0;
	}
  }

  window.requestAnimationFrame(scrollStep);
}
